<template lang="pug">
	div(id="kt-sales-goals")
		div(class='kt-sales-goals-header')
			slot(name="team-member-filter" :fCU="false" :fTM="d_canSG")
		div(class="kt-sales-goals-content")
			b-card(no-body v-for="MoQtr in c_bcSGs" :key="MoQtr.key") 
				b-card-header
					b-button(variant="none" v-b-toggle="'bc-sg-by-'+MoQtr.key")
						fa-icon(icon="chevron-down")
					span {{MoQtr.lbl}}
				b-collapse(:id="'bc-sg-by-'+MoQtr.key" visible=true)
					p(class="note" v-if="d_canSG && !d_tmFilter") Select a Team Member to view and set their {{MoQtr.key}} sales goals
					div(v-if="d_canSG")
						div(class="header")
							span(v-if="d_canSG" class="btn btn-link" title="Add Goals" @click="m_addGoals(MoQtr)") Add {{d_tmFilter? null:"Company's"}} {{MoQtr.keyLbl}} Goals
							b-dropdown(variant="outline-secondary" right lazy=true v-if="MoQtr.goals.length >1")
								div(class="dropdown-item" v-for="(g,ix) in MoQtr.goals" :key="ix" @click="g.fn_tglVsbl()")
									input(type="checkbox" :checked="g.vsbl")
									span  {{g.yr}}
								template(v-slot:button-content )
									| Show Years
						p(class="note" v-if="!MoQtr.goals.length") No {{MoQtr.key}} goals added for {{d_tmFilter? d_tmFilter.teamMemberName:"Company"}}
						div(class="content" v-else)
							b-table-simple(small  hover)
								b-thead
									b-tr
										b-th(rowspan=2)
										b-th(v-for="(g,ix) in MoQtr.goals.filter(x=> x.vsbl)" :key="ix" class="yr" :colspan="g.vsblTgt?2:1")
											div(v-if="g.fn_isEdt()" class="btns")
												b-button(class="btn-save" variant="primary" @click="m_saveGoals(g, MoQtr)") Save{{g.sgId?' Changes':null}}
												b-button(class="btn-cancel" variant="outline-secondary" @click="m_cancelGoals(g)") Cancel
											span Year
											span {{g.yr}}
											b-dropdown(variant="grey1" lazy=true right :class="g.vsblTgt?null:'no-tgt-col'" )
												tempalte(slot="default" slot-scope="{hide}")
													div(v-for="(opt, oix) in g.fn_ddOpts()" :key="oix" class="dropdown-item" :class="opt.class||null"
															@click="opt.fn_click(g, MoQtr); hide()")
														fa-icon(:icon="opt.icon")
														| {{opt.lbl}}
												template(slot="button-content")
													fa-icon(icon="bars")

									b-tr(class="tgt-act")
										b-th(v-for="(x, ix) in MoQtr.thTgtAct" :key="ix" :class="x")
								b-tbody
									b-tr(v-for="(row, rix) in MoQtr.goalsRows" :key="rix")
										b-td {{row.lbl}}
										b-td(v-for="(gv, gvix) in row.goalVals" :key="gvix" v-if="gv.goalRef.fn_isVsbl(gv.key)"
											:class="[gv.key, gv.key=='Act' && gv.valRef.ActOvrd?'ActOvrd':null]" )
											b-input-group(prepend="$" v-if="gv.goalRef.fn_isEdt(gv.key) && row.ix!='ttl'")
												b-form-input(type="text" :value="gv.valVM" :state="gv.state" @change="m_valChg(gv, $event)")
											span(v-else) {{gv.valVM}}
												fa-icon(v-if="gv.valRef[gv.key+'Inv'] && gv.valVM" icon="exclamation")
							div(class="info")
								div(v-if="MoQtr.goals.filter(x=> x.ovrdAct).length")
									span *
									span 
										|Indicates the "Actual" value is overridden (manually entered), instead of being extracted from Opportunity records.
										|To maintain the integrity of your sales data, it is recommended that sales infomration is retained in the corresponding Opportunity records.
								div(v-if="MoQtr.goals.filter(x=> x.invld).length")
									span 
										fa-icon(icon="exclamation") 
									span 
										|Indicates monthly values do not add up to the corresponding quarterly value.
			b-card(no-body) 
				b-card-header
					b-button(variant="none" v-b-toggle="'bc-sg-quest-tg'")
						fa-icon(icon="chevron-down")
					span {{d_isCU?'My ':''}} Annual Quest to Goal for {{d_metrics.selYr}}
					b-form-select(v-if="c_yrs" v-model="d_metrics.selYr" :options="c_yrs" plain @change="d_metrics.fn_chg()")
				b-collapse(id="bc-sg-quest-tg" visible=true)
					div(class="goal")
						div(class="hdr") Goal Metrics
						p(class="note" v-if="!c_qtgG.items") No {{d_metrics.selYr}} goals added for {{d_tmFilter? d_tmFilter.teamMemberName:"Company"}}
						vue-gauge(v-else :options="c_qtgG.vgOpts" :key="c_qtgG.vgKey")
						div(v-for="(itm, iix) in c_qtgG.items||[]" :key="iix" :class="itm.class" class="item") 
							div
								span {{itm.lbl}}:
							div
								span ${{itm.val|| ' - '}}
								span(v-if="itm.pct") ({{itm.pct + itm.pctLbl}})
						
					div(class="ppl")
						div(class="hdr") Pipeline Metrics
						div(v-for="(itm, iix) in c_qtgP" :key="iix" class="item") 
							div
								kt-tt-info(:p_infoTxt="itm.info")
								span {{itm.lbl}}:
							div
								span {{itm.val}}
								span(v-if="itm.pct") ({{itm.pct + itm.pctLbl}})
			b-card(no-body) 
				b-card-header
					b-button(variant="none" v-b-toggle="'bc-sg-notes'")
						fa-icon(icon="chevron-down")
					span Notes for {{d_notes.selYr}}
					b-form-select(v-if="c_yrs" v-model="d_notes.selYr" :options="c_yrs" plain @change="d_notes.fn_chg()")
				b-collapse(id="bc-sg-notes" visible=true)
					p(class="note" v-if="c_notes===null") To add notes, monthly or quarterly goals for {{d_metrics.selYr}} must first be added/saved.
					div(v-else v-for="(note, nix) in c_notes" :key="nix")
						div(class="title") {{note.lbl}}
						div(class="items-cont")
							div(class="item" v-for="(nv, nvix) in d_notes.data.filter(x=> note.fn_fltr(x))" :key="nvix")
								b-input-group
									b-form-textarea(size="sm" v-model="nv.noteText" :placeholder="'Enter your note for: '+note.lbl" :disabled="!nv.inEdit")
									b-input-group-append
										b-button(v-if="nv.inEdit" class="btn-save" variant="none" title="Save" @click="m_saveNote(note, nv)")
											fa-icon(icon="check")
										b-button(v-else class="btn-edit" variant="none" title="Edit" @click="nv._bkp = nv.noteText; nv.inEdit=true")
											fa-icon(icon="pencil-alt")
										b-button(v-if="nv.sgnId && nv.inEdit" class="btn-cancel" variant="none" title="Cancel" @click="nv.noteText = nv._bkp; nv.inEdit=null")
											fa-icon(icon="undo")
										b-button(v-else class="btn-delete" variant="none" title="Delete" @click="m_delNote(note, nv)")
											fa-icon(icon="times")
										
								div(class="info")
									span(v-if="nv.updatedUTC") Updated: {{note.fn_fmtDtm(nv.updatedUTC)}}
									span(v-if="nv.addedUTC") Added: {{note.fn_fmtDtm(nv.addedUTC)}} 
									
						b-button(class="btn-add" variant="outline-primary" title="Add" @click="m_addNote(note, $event)")
							fa-icon(icon="plus") 
							| Add
						small(class="text-grey5 pl-2") Click to add a note


</template>

 <script>
import {salesGoals as api} from "@/utils/api.js";
import util, {kbdpAlert, fn_getModal_addGoal} from "@/utils/util.js";
import {userSettings, userInfo, refData} from "@/utils/ref-data.js";

import VueGauge from "vue-gauge";


const const_bkp = {};
export default {
	name: "kt-sales-goals",
	components: {
		'vue-gauge': VueGauge
	},
	beforeCreate() {
		let kbdp = this.$parent;
		const_bkp.cu = kbdp.d_cuFilter;
		const_bkp.tm = kbdp.d_tmFilter;
	},
	beforeDestroy() {
		if (!this.d_canSG) {
			let kbdp = this.$parent;
			kbdp.d_cuFilter = const_bkp.cu;
			kbdp.d_tmFilter = const_bkp.tm;
		}
	},
	created() {
		let kbdp = this.$parent;
		this.d_canSG = userSettings.permissions.STMSG === true;
		if (this.d_canSG) {
			this.d_tmFilter = kbdp.d_tmFilter;
			this.d_isCU = null;
			kbdp.d_cuFilter = null;
		}
		else {
			this.d_tmFilter = userInfo.getUserInfo().teamMember;
			this.d_isCU = true;
			kbdp.d_cuFilter = true;
		}
		//if (this.d_tmFilter) fn_getSalesGoals(this);
		fn_getSalesGoals(this);
	},
	mounted() {},
	data() {
		let curYr = new Date().getFullYear();
		return {
			d_currYr: curYr,
			d_currDt: new Date().toLocaleDateString(),
			d_canSG: null,
			d_tmFilter: null,
			d_isCU: null,

			d_goals: [],
			d_goalsRows: {m: [], q: []},

			d_metrics: {
				selYr: curYr,
				data: {},
				fn_chg: () => fn_getSalesGoals_Mtrcs(this)
			},
			d_notes: {
				selYr: curYr,
				data: [],
				fn_chg: () => fn_getSalesGoals_Notes(this)
			},

		};
	},
	props: {},
	computed: {
		c_tmFilter() {
			return this.$parent.d_tmFilter;
		},
		c_yrs() {
			let yrs = this.d_goals.map(x => x.yr);
			yrs.push(this.d_currYr);
			yrs = yrs.filter((val, ix, arry) => arry.indexOf(val) === ix);
			yrs = yrs.sort((a, b) => a.yr < b.yr ? 1 : -1);

			return yrs.map(x => ({text: x, value: x}));
		},
		c_bcSGs() {
			//B-Collapse Sales Goals
			// console.log('c_bcSGs', this.d_goals.length);
			let pfx = this.d_isCU ? 'My ' : '';
			let out = [
				{
					prdKey: 'm',
					key: 'monthly',
					lbl: pfx + 'Monthly Sales Goals',
					goals: this.d_goals.filter(x => x.prdKey == 'm').sort((a, b) => a.yr < b.yr ? 1 : -1),//!!Sort = IMPORTANT
					goalsRows: this.d_goalsRows['m'],
					rowLbls: refData.months,
				},
				{
					prdKey: 'q',
					key: 'quarterly',
					lbl: pfx + 'Quarterly Sales Goals',
					goals: this.d_goals.filter(x => x.prdKey == 'q').sort((a, b) => a.yr < b.yr ? 1 : -1),//!!Sort = IMPORTANT
					goalsRows: this.d_goalsRows['q'],
					rowLbls: [1, 2, 3, 4].map(q => 'Qtr' + q),
				}
			];
			out.forEach((MoQtr, ix) => {

				MoQtr.keyLbl = util.fn_humanizeLabel(MoQtr.key);

				fn_setGoalsRows(this, MoQtr);

				let glsVsb = MoQtr.goals.filter(g => g.vsbl);
				MoQtr.thTgtAct = !glsVsb.length ? [] : glsVsb.map(g => {
					let arry = ['Act'];
					// if (g.ovrdAct) arry[0] += 'Ovrd';
					if (g.vsblTgt) arry.unshift('Tgt');
					return arry;
				}).reduce((x, y) => x.concat(y));
			});
			return out;
		},
		c_qtgTtl() {
			let cy = this.d_goals.filter(x => x.yr == this.d_metrics.selYr);
			if (!cy.length) return null;
			cy = cy.length == 1 ? cy[0] : cy.filter(x => x.prdKey == 'q')[0];
			return cy.ttlVal;
		},
		c_qtgG() {
			//Quest to Goal - Goal Metrics
			let qtgTtl = this.c_qtgTtl;

			if (!qtgTtl) return {};
			let pctOfTgt = !qtgTtl.Tgt ? 0 : Math.round(qtgTtl.Act * 100 / qtgTtl.Tgt);

			let arcClr = pctOfTgt < 10 ? '#dc3545' : pctOfTgt > 90 ? '#28a745' : '#a1cbc9';
			let arcDlm = pctOfTgt >= 100 ? 99 : (pctOfTgt || 1);
			let qtg = {
				vgKey: pctOfTgt,
				vgOpts: {
					chartWidth: 200,
					rangeLabel: ['0%', '100%'],

					arcColors: [arcClr, '#e9ecef'],
					arcDelimiters: [arcDlm],

					arcLabels: [util.fn_fmtMoney(qtgTtl.Act, true)],
					centralLabel: pctOfTgt + '%',
					// outerNeedle: true,
					needleValue: pctOfTgt,
					needleColor: '#4fa4ff',
				},
				items: [
					{
						lbl: 'Annual Target',
						val: this.m_valFmt(qtgTtl.Tgt),
						pct: null,
						pctLbl: null,
						class: 'Tgt',
					},
					{
						lbl: 'Achieved',
						val: this.m_valFmt(qtgTtl.Act),
						pct: pctOfTgt,
						pctLbl: "% of Target",
						class: ['Act'],
					},
				]
			};

			if (qtgTtl.Tgt >= qtgTtl.Act) {
				qtg.items.push({
					lbl: 'Remaining',
					val: this.m_valFmt(qtgTtl.Tgt - qtgTtl.Act),
					pct: !qtgTtl.Tgt ? null : ((qtgTtl.Tgt - qtgTtl.Act) * 100 / qtgTtl.Tgt).toFixed(0),
					pctLbl: '% of Target',
					class: qtgTtl.Tgt === null ? null : 'Rem',
				});
			}
			else {
				qtg.items.push({
					lbl: 'Exceeded by',
					val: this.m_valFmt(qtgTtl.Act - qtgTtl.Tgt),
					pct: !qtgTtl.Tgt ? null : ((qtgTtl.Act - qtgTtl.Tgt) * 100 / qtgTtl.Tgt).toFixed(0),
					pctLbl: '% of Target',
					class: 'Exc',
				});
			}
			return qtg;
		},
		c_qtgP() {
			//Quest to Goal - Pipeline Metrics

			let selYr = this.d_metrics.selYr;
			let isPY = selYr < this.d_currYr; //Previous Year

			let op = this.d_metrics.data;
			let ppl = [
				{
					lbl: 'Opportunities in Pipeline',
					val: op.opprCnt || '0',
					info: `# of Opportunities that are due in ${selYr}, and the selected Team Member is the “Internal Contact”. \n\
					The metric for prior years include both awarded and not awarded opportunities, \
					while metric for current or future years only include opportunities that are not yet awarded (deal in progress). \n\
					Opportunities “Not Pursued” and ”Archived” are excluded.`
				},
				{
					lbl: 'Total Pipeline Value',
					val: op.valSum == undefined ? null : '$' + this.m_valFmt(op.valSum),
					info: 'Total value of the opportunities in pipeline'
				},
				{
					lbl: 'Win Probability (average)',
					val: op.winPrbAvg == undefined ? null : op.winPrbAvg + '%',
					info: 'Average "Win Probability" (dropdown selection) of the opportunities in pipeline'
				},

				{
					lbl: 'Win Rate' + (isPY ? '' : ' (last 12 mo)'),
					val: op.winRate == undefined ? null : op.winRate + '%',
					info: `% (ratio) of opportunities awarded vs non-awarded, and were due in ${isPY ? selYr : 'the last 12 months'}, \
					and the selected Team Member is the “Internal Contact”. \n\
					Opportunities “Not Pursued” and ”Archived” are excluded.`
				},
				{
					lbl: 'High Probable Opportunities',
					val: op.opprCntHP || '0',
					info: '# of Opportunities in pipeline with 80% or higher Win Probability'
				},
				{
					lbl: 'High Probable Pipeline Value',
					val: op.valSumHP == undefined ? null : '$' + this.m_valFmt(op.valSumHP),
					info: 'Total value of high probable Opportunities in pipeline (80% or higher Win Probability.)'
				},

			];


			if (isPY) return ppl;


			//Only applicable for current/future years
			let qtgTtl = this.c_qtgTtl;
			let rem = qtgTtl ? qtgTtl.Tgt - qtgTtl.Act : null;
			if (rem > 0) {
				if (op.valSum >= 0) {
					let tpv = ppl[1];
					tpv.pct = (op.valSum * 100 / rem).toFixed(0);
					tpv.pctLbl = '% of Remaining';

				}

				if (op.valSumHP >= 0) {
					let hpv = ppl[5];
					hpv.pct = (op.valSumHP * 100 / rem).toFixed(0);
					hpv.pctLbl = '% of Remaining';
				}
			}

			return ppl;
		},
		c_notes() {
			let goalYr = this.d_goals.filter(x => x.yr == this.d_notes.selYr && x.sgId)[0];
			if (!goalYr) return null;

			let sgId = goalYr.sgId;
			if(refData.salesGoalNoteCategories)
			{
			return refData.salesGoalNoteCategories.map(sgnc => {
				return {
					sgId,
					ncId: sgnc.id,
					lbl: sgnc.ctgry,
					fn_fltr: (n) => n.ncId == sgnc.id && n.sgId == sgId,
					fn_fmtDtm: (dtm) => util.fn_fmtDtmStr(dtm, true),
				};
			});
			} else	return null;  
		}
	},
	methods: {
		m_addGoals(MoQtr) {
			fn_addGoalsRoutine(this, MoQtr);
			util.fn_wss_uc(true);
		},
		m_saveGoals(goals, MoQtr) {
			fn_saveGoalsRoutine(goals, MoQtr);
		},
		m_cancelGoals(g) {
			if (!g.sgId) {
				util.fn_spliceById(this.d_goals, 'clntId', g.clntId);
			}
			else {
				g.fn_restBkp();
				g.fn_setOvrAct();
				g.edtTgt = g.edtAct = null;
			}

			fn_wss_uc_rem(this);
		},
		m_valFmt(val) {
			if (val === null || val === '') return null;
			else if (!isNaN(val)) return Number(val).toLocaleString('en');
		},
		m_valChg(gv, chgVal) {
			let val = (chgVal || '').replaceAll(',', '').trim();

			if (isNaN(val)) {
				gv.state = false;
				gv.valVM = chgVal;
			}
			else {
				gv.state = null;
				gv.valVM = this.m_valFmt(val);

				gv.valRef[gv.key] = val == '' ? null : Number(val);

				if (gv.key == 'Act') {
					gv.valRef.ActOvrd = val == '' ? null : true;
				}

				let gr = gv.goalRef;
				gr.fn_calcYrTtl(gv.key);
			}
		},

		m_addNote(note, e) {
			this.d_notes.data.push({
				clntId: Date.now() + '-' + note.ncId,
				sgId: note.sgId,
				ncId: note.ncId,
				noteText: null,
				addedUTC: null,
				inEdit: true,
			});
			let ic = $(e.target).parent().children('.items-cont')[0];

			if (!ic) return;
			setTimeout(() => {
				ic.scrollTop = ic.scrollHeight;
				$(ic).children('.item').last().find('textarea').focus();
			}, 50);

		},
		m_saveNote(note, nv) {
			let sgnData = {
				teamMemberId: (this.d_tmFilter || {}).teamMemberId || null,
				salesGoalNoteId: nv.sgnId,
				noteCategoryId: nv.ncId,
				noteText: nv.noteText,
			};
			let fn_cb = (ups) => {
				Object.keys(ups || {}).forEach(k => {
					nv[k] = ups[k];
				});
				nv.inEdit = null;
				delete nv.clntId;
			};
			fn_saveNote(note.sgId, sgnData, fn_cb);
		},
		m_delNote(note, nv) {
			let ix = this.d_notes.data.map(x => x.clntId || x.sgnId).indexOf(nv.clntId || nv.sgnId);
			let fn_cb = (ups) => {
				this.d_notes.data.splice(ix, 1);
			};

			let content = {
				titleText: 'Confirm Delete',
				message1: `Are you sure you want to delete the note for "${note.lbl}"?`
			};
			let cm = util.fn_getModal_confirm(this, content);
			cm.opt.okTitle += ', Delete';
			cm.opt.cancelTitle += ', Keep';
			this.$bvModal.msgBoxConfirm(cm.msgVNodes, cm.opt).then(resp => {
				if (!resp) return;

				if (nv.sgnId) {
					let sgnData = {
						teamMemberId: (this.d_tmFilter || {}).teamMemberId || null,
						salesGoalNoteId: nv.sgnId,
						delete: true
					};
					fn_saveNote(nv.sgId, sgnData, fn_cb);
				}
				else fn_cb();
			});
		}
	},
	watch: {
		c_tmFilter(nv, ov) {
			if (!this.d_canSG) return;
			this.d_tmFilter = nv;
			fn_getSalesGoals(this);
			//if (nv) {
			//	fn_getSalesGoals(this);
			//}
			//else {
			//	this.d_goals = [];
			//	this.d_metrics = {selYr: this.d_currYr, data: {}};
			//	this.d_notes = {selYr: this.d_currYr, data: []};

			//	this.d_goalsRows.m.length = 0;
			//	this.d_goalsRows.q.length = 0;
			//}
		},
	},

};

class Goals {
	constructor (vc, prdKey, data) {
		data = data || {};
		this.clntId = Date.now() + prdKey + data.sgId;

		this.vcRef = vc;
		this.prdKey = prdKey;
		this.sgId = data.sgId || null;
		this.yr = data.yr || null;

		this.goalVals = this.fn_gvParse(data.goalVals);
		this.ttlVal = {Tgt: null, Act: null};

		this.vsbl = true;
		this.vsblTgt = true;
		this.edtTgt = null;
		this.edtAct = null;
		this.ovrdAct = null;
		this.invld = null;

		this.fn_setOvrAct();

		this.fn_isVsbl = (key) => {
			return this.vsbl && (key == 'Tgt' ? this.vsblTgt : true);
		};
		this.fn_isEdt = (key) => {
			if (key) return key == 'Tgt' ? this.edtTgt : key == 'Act' ? this.edtAct : null;
			else return this.edtTgt || this.edtAct;
		};
		this.fn_tglVsbl = () => {
			return this.vsbl = !this.vsbl;
		};

		this.fn_calcYrTtl = (key) => {
			let keys = key ? [key] : ['Tgt', 'Act'];
			keys.forEach(key => {
				let data = this.goalVals.map(x => x[key]);
				this.ttlVal[key] = util.fn_calcSum(data, true);
			});
		};

		this.fn_validation = () => {
			let compareWith = this.vcRef.d_goals.filter(x => x.yr == this.yr && x.prdKey != this.prdKey)[0];
			if (!compareWith) return;

			let qtrCheck;
			let moCheck;
			if (this.prdKey == 'q') {
				qtrCheck = this.goalVals;
				moCheck = compareWith.goalVals;
			}
			else {
				qtrCheck = compareWith.goalVals;
				moCheck = this.goalVals;
			}

			qtrCheck.forEach(qc => {
				let qtrMnths = moCheck.filter(x => x.qtr == qc.Num);
				['Tgt', 'Act'].forEach(key => {
					let data = qtrMnths.map(x => x[key]);
					let sum = util.fn_calcSum(data, true);
					let invalid = (sum || 0) != (qc[key] || 0);
					let propNm = key + 'Inv';
					qc[propNm] = invalid;
					qtrMnths.forEach(x => x[propNm] = invalid);
				});
			});

			let invalid = qtrCheck.filter(x => x.ActInv || x.TgtInv).length;
			this.invld = compareWith.invld = invalid ? true : null;

		};
		this.fn_edtBkp = () => {
			if (this._bkp) return;
			let bkp = {};
			['goalVals', 'ttlVal'].forEach(k => bkp[k] = this[k]);
			this._bkp = JSON.parse(JSON.stringify(bkp));
		};
		this.fn_restBkp = () => {
			if (!this._bkp) return;

			this.goalVals.forEach(gv => {
				let gbBkp = (this._bkp.goalVals || []).filter(x => x.Num == gv.Num)[0] || {};
				gv.Tgt = gbBkp.Tgt;
				gv.Act = gbBkp.Act;
			});

			this.ttlVal.Tgt = this._bkp.ttlVal.Tgt;
			this.ttlVal.Act = this._bkp.ttlVal.Act;

			delete this._bkp;
		};
	}

	fn_ddOpts() {
		let opts = [];
		let isInEdit = this.edtTgt || this.edtAct;
		let canSG = this.vcRef.d_canSG;

		if (!this.edtTgt && canSG) opts.push({
			lbl: 'Edit Targets',
			icon: 'pencil-alt',
			fn_click: (goals) => {
				goals.fn_edtBkp();
				goals.edtTgt = goals.vsblTgt = true;
				util.fn_wss_uc(true);
			},
		});
		if (!this.edtAct && canSG) opts.push({
			lbl: 'Override Actuals',
			icon: 'pencil-alt',
			fn_click: (goals) => {
				goals.fn_edtBkp();
				goals.edtAct = goals.ovrdAct = true;
				util.fn_wss_uc(true);
			},
			class: 'ovrAct'
		});
		// if (isInEdit) opts.push({
		// 	lbl: 'Save Changes',
		// 	icon: 'check',
		// 	fn_click: (goals, MoQtr) => fn_saveGoalsRoutine(goals, MoQtr),
		// });

		if (this.prdKey == 'q' && canSG) {
			let goalsMo = this.vcRef.d_goals.filter(x => x.yr == this.yr && x.prdKey == 'm')[0];
			if (goalsMo) opts.push({
				lbl: 'Calculate from Monthly',
				icon: 'calculator',
				fn_click: (goals, MoQtr) => {
					this.goalVals.forEach(gvQtr => {
						['Tgt', 'Act'].forEach(key => {
							let qtrMnths = goalsMo.goalVals.filter(x => x.qtr == gvQtr.Num);
							let data = qtrMnths.map(x => x[key]);
							gvQtr[key] = util.fn_calcSum(data, true);
							if (key == 'Act' && qtrMnths.filter(x => x.ActOvrd).length) gvQtr.ActOvrd = true;
						});
					});

					this.fn_calcYrTtl();
					if (!isInEdit) fn_saveGoalsRoutine(goals, MoQtr);
					else {
						this.fn_validation();
						this.fn_setOvrAct();
					}
				},
			});
		}

		if (this.ovrdAct && canSG) opts.push({
			lbl: 'Reset/Refresh Actuals',
			icon: 'sync',
			fn_click: (goals, MoQtr) => {
				let fn_cb = isInEdit ? null : () => fn_saveGoalsRoutine(goals, MoQtr);
				fn_getSalesGoals_Act(this.vcRef, goals, fn_cb);
			},
		});

		// if (isInEdit && canSG) opts.push(
		// 	// {
		// 	// 	lbl: 'Cancel Changes',
		// 	// 	icon: 'undo',
		// 	// 	fn_click: (goals) => {
		// 	// 		goals.fn_restBkp();
		// 	// 		goals.fn_setOvrAct();
		// 	// 		goals.edtTgt = goals.edtAct = null;
		// 	// 	}
		// 	// },
		// 	{
		// 		lbl: 'Paste from Clipboard',
		// 		icon: 'paste',
		// 		fn_click: (goals) => {},
		// 	},
		// );
		if (canSG) {
			opts.push(
				{
					lbl: 'Delete',
					icon: 'times',
					fn_click: (goals, MoQtr) => fn_delGoalsRoutine(goals, MoQtr),
				}
			);
		}
		opts.push(
			{
				// lbl: '',
				icon: 'bullseye',
				fn_click: (goals) => {
					goals.vsblTgt = !goals.vsblTgt;
				},
				class: 'tgl-tgt'
			}
		);

		return opts;
	}
	fn_setOvrAct() {
		this.ovrdAct = this.goalVals.filter(x => x.ActOvrd).length > 0 ? true : null;
	}
	fn_gvParse(goalVals) {
		if ((goalVals || []).length == 0) {
			switch (this.prdKey) {
				case 'm': goalVals = refData.months.map((m, ix) => ({Num: ix + 1})); break;
				case 'q': goalVals = [1, 2, 3, 4].map(q => ({Num: q})); break;
			}
		}
		goalVals.forEach(x => {
			['Tgt', 'Act', 'ActOvrd', 'TgtInv', 'ActInv'].forEach(k => {
				if (x[k] == undefined) x[k] = null;
			});
			if (this.prdKey == 'm') x.qtr = Math.ceil(x.Num / 3);
		});
		// console.log(goalVals.map(x => x.Num + '-' + x.qtr));
		return goalVals;
	}
}

function fn_setGoalsRows(vc, MoQtr) {
	let goals = vc.d_goals.filter(x => x.prdKey == MoQtr.prdKey && x.vsbl).sort((a, b) => a.yr < b.yr ? 1 : -1); //!!Sort = IMPORTANT
	if (!goals.length) {
		MoQtr.goalsRows.length = 0;
		return;
	}
	//Months/Quarters
	let rows = MoQtr.rowLbls.map((lbl, ix) => {
		let rowMQ = {lbl, ix, goalVals: []};
		goals.forEach(goal => {
			let val = goal.goalVals.filter(gv => ix + 1 == gv.Num)[0];
			['Tgt', 'Act'].forEach(key => {
				rowMQ.goalVals.push({
					key,
					goalRef: goal,
					valRef: val,
					valVM: vc.m_valFmt(val[key]),
					state: null,
				});
			});
		});
		return rowMQ;
	});

	//Total Year
	let rowYR = {lbl: 'Total', ix: 'ttl', goalVals: []};
	goals.forEach(goal => {
		let val = goal.ttlVal;
		['Tgt', 'Act'].forEach(key => {
			rowYR.goalVals.push({
				key,
				goalRef: goal,
				valRef: val,
				valVM: vc.m_valFmt(val[key]),
				state: null,
			});
		});
	});
	rows.push(rowYR);

	//ref --> this d_goalsRows[prdKey]
	MoQtr.goalsRows.length = 0;
	MoQtr.goalsRows.push(...rows);

	// MoQtr.goalsRows = rows;
}

function fn_addGoalsRoutine(vc, MoQtr) {
	let yrOpts = fn_getYrOpts();
	let yrs = [].concat(yrOpts[0], yrOpts[1], yrOpts[2].options).filter(x => !x.disabled).map(x => x.value);
	let yrData = {
		yr: yrs.indexOf(vc.d_currYr) > -1 ? vc.d_currYr : yrs[0] || null,
	};
	let agm = fn_getModal_addGoal(vc, MoQtr, yrOpts, yrData);

	vc.$bvModal.msgBoxConfirm([agm.msgVNode], agm.opt).then(resp => {
		if (!resp || !yrData.yr) return;
		else {
			let existing = vc.d_goals.filter(x => x.yr == yrData.yr && x.prdKey != MoQtr.prdKey)[0];
			if (existing) yrData.sgId = existing.sgId;
			let goals = new Goals(vc, MoQtr.prdKey, yrData);
			goals.edtTgt = true;
			vc.d_goals.push(goals);
			fn_getSalesGoals_Act(vc, goals, null); //To get actuals for the specified year
		}
	});

	function fn_getYrOpts() {
		let currYr = vc.d_currYr;
		let nxtYr = currYr + 1;
		let existing = MoQtr.goals.map(x => x.yr);
		return [
			{
				value: nxtYr,
				text: `Next Year (${nxtYr})`,
				disabled: existing.indexOf(nxtYr) > -1,
			},
			{
				value: currYr,
				text: `Current Year (${currYr})`,
				disabled: existing.indexOf(currYr) > -1,
			},
			{
				label: 'Previous Years...',
				options: [1, 2, 3, 4, 5].map(x => ({
					value: currYr - x,
					text: currYr - x,
					disabled: existing.indexOf(currYr - x) > -1,
				}))
			}
		];
	}

}
function fn_saveGoalsRoutine(goals, MoQtr) {

	let invalid = MoQtr.goalsRows.filter(gr => {
		return gr.goalVals.filter(gv => gv.goalRef.yr == goals.yr && gv.state === false).length > 0;
	});
	if (invalid.length) {
		let lbls = invalid.map(x => x.lbl).join(", ");
		kbdpAlert.showErr(`Invalid values are entered for the following ${MoQtr.key.slice(0, -2) + '(s)'}:\n${lbls}`);
		return;
	}

	let vc = goals.vcRef;
	let sgData = {
		teamMemberId: (vc.d_tmFilter || {}).teamMemberId, //Not null
		periodKey: goals.prdKey,
		year: goals.yr,
		values: goals.goalVals.map(x => {
			return {
				period: x.Num,
				target: x.Tgt,
				actualOvrd: x.ActOvrd ? x.Act : null,
			};
		}),
	};

	let fn_cb = (resp) => {
		let recHdr = resp.upsRecHdr || {};
		if (!goals.sgId) goals.sgId = recHdr.salesGoalId;

		goals.fn_validation();
		goals.fn_setOvrAct();
		goals.edtTgt = goals.edtAct = null;
		delete goals._bkp;

		fn_wss_uc_rem(vc);
	};

	fn_saveSalesGoal(goals.sgId, sgData, fn_cb);
}
function fn_delGoalsRoutine(goals, MoQtr) {
	let vc = goals.vcRef;
	let content = {
		titleText: 'Confirm Delete',
		message1: `Are you sure you want to delete ${MoQtr.key} goals for ${goals.yr}?`
	};
	let cm = util.fn_getModal_confirm(vc, content);
	cm.opt.okTitle += ', Delete';
	cm.opt.cancelTitle += ', Keep';
	vc.$bvModal.msgBoxConfirm(cm.msgVNodes, cm.opt).then(resp => {
		if (!resp) return;

		if (goals.sgId) {
			let reqPrms = {
				teamMemberId: (vc.d_tmFilter || {}).teamMemberId || null,
				periodKey: goals.prdKey,
			};
			fn_deleteSalesGoal(goals.sgId, reqPrms, fn_cb);
		}
		else fn_cb();
	});

	function fn_cb() {
		util.fn_spliceById(vc.d_goals, 'clntId', goals.clntId);
		fn_wss_uc_rem(vc);
	}

}

function fn_getSalesGoals(vc) {
	let reqPrms = {
		currentUser: vc.d_isCU || null,
		teamMemberId: (vc.d_tmFilter || {}).teamMemberId || null
	};

	kbdpAlert.showLoading('Sales Goals', true);
	api.fn_getSG(reqPrms).then(resp => {
		if (resp.error) {
			kbdpAlert.showErr('Unable to Load Sales Goals. ' + resp.error || '');
			return;
		}
		else kbdpAlert.clear();
		vc.d_goals = [];
		(resp.goals || []).forEach(gr => {
			if (gr.moVals) {
				let data = {yr: gr.year, sgId: gr.salesGoalId, goalVals: gr.moVals, };
				let goals = new Goals(vc, 'm', data);
				goals.fn_calcYrTtl();
				// goals.fn_validation();
				vc.d_goals.push(goals);
			}
			if (gr.qtrVals) {
				let data = {yr: gr.year, sgId: gr.salesGoalId, goalVals: gr.qtrVals, };
				let goals = new Goals(vc, 'q', data);
				goals.fn_calcYrTtl();
				goals.fn_validation();
				vc.d_goals.push(goals);
			}
		});

		vc.d_metrics.selYr = vc.d_currYr;
		vc.d_notes.selYr = vc.d_currYr;

		vc.d_metrics.data = resp.metrics || {};

		let n = resp.notes || [];
		n.forEach(x => x.inEdit = null);
		vc.d_notes.data = n;

	});
}
function fn_getSalesGoals_Act(vc, goals, fn_cb) {
	let reqPrms = {
		currentUser: vc.d_isCU || null,
		teamMemberId: (vc.d_tmFilter || {}).teamMemberId || null,
		year: goals.yr,
		periodKey: goals.prdKey
	};

	kbdpAlert.showLoading(null, true);
	api.fn_getSG(reqPrms).then(resp => {
		if (resp.error) {
			kbdpAlert.showErr('Unable to Load Actuals. ' + resp.error || '');
			return;
		}
		else kbdpAlert.clear();

		//Reset/Refresh year + Add New -get actuals 
		goals.goalVals.forEach(gv => {
			gv.ActOvrd = null;
			gv.Act = ((resp.goals || []).filter(x => x.Num == gv.Num)[0] || {}).Act || null;
		});
		goals.fn_setOvrAct();
		goals.fn_calcYrTtl();

		if (fn_cb) fn_cb();
	});
}
function fn_getSalesGoals_Mtrcs(vc) {
	let reqPrms = {
		currentUser: vc.d_isCU || null,
		teamMemberId: (vc.d_tmFilter || {}).teamMemberId || null,
		year: vc.d_metrics.selYr
	};

	kbdpAlert.showLoading(null, true);
	api.fn_getSG(reqPrms, 'metrics').then(resp => {
		if (resp.error) {
			kbdpAlert.showErr('Unable to Load Pipeline Metrics. ' + resp.error || '');
			return;
		}
		else kbdpAlert.clear();
		vc.d_metrics.data = resp.metrics || {};
	});
}
function fn_getSalesGoals_Notes(vc) {
	let reqPrms = {
		currentUser: vc.d_isCU || null,
		teamMemberId: (vc.d_tmFilter || {}).teamMemberId || null,
		year: vc.d_notes.selYr
	};

	kbdpAlert.showLoading(null, true);
	api.fn_getSG(reqPrms, 'notes').then(resp => {
		if (resp.error) {
			kbdpAlert.showErr('Unable to Load Notes. ' + resp.error || '');
			return;
		}
		else kbdpAlert.clear();

		let n = resp.notes || [];
		n.forEach(x => x.inEdit = null);
		vc.d_notes.data = n;
	});
}

function fn_saveSalesGoal(sgId, sgData, fn_cb) {
	kbdpAlert.showSaving('Sales Goals');
	api.fn_saveSG(sgId, sgData).then(resp => {
		if (resp.error) {
			kbdpAlert.showErr('Unable to save Sales Goals. ' + resp.error || '');
			return;
		}
		else kbdpAlert.clear();
		fn_cb(resp);
		kbdpAlert.showOk('Sales Goals saved successfully.');
	});
}
function fn_deleteSalesGoal(sgId, reqPrms, fn_cb) {
	kbdpAlert.showDeleting('Sales Goal');
	api.fn_delSG(sgId, reqPrms).then(resp => {
		if (resp.error) {
			kbdpAlert.showErr('Unable to delete Sales Goals. ' + resp.error || '');
			return;
		}
		else kbdpAlert.clear();

		fn_cb();
		kbdpAlert.showOk('Sales Goals deleted successfully.');
	});
}

function fn_saveNote(sgId, sgnData, fn_cb) {
	let actTxt = sgnData.delete ? 'delete' : 'save';
	kbdpAlert.showLoading(null, true);
	api.fn_saveSGN(sgId, sgnData).then(resp => {
		if (resp.error) {
			kbdpAlert.showErr(`Unable to ${actTxt} Sales Goals Note` + resp.error || '');
			return;
		}
		else kbdpAlert.clear();
		if (fn_cb) fn_cb(resp.upsRecHdr);
		kbdpAlert.showOk(`Sales Goals Note ${actTxt}d successfully.`);
	});
}

function fn_wss_uc_rem(vc) {
	if (vc.d_goals.filter(x => x.fn_isEdt()).length == 0) util.fn_wss_uc(false);
}

</script>

<style lang="less">
#kt-sales-goals {
	height: 100%;
	> .kt-sales-goals-header {
		display: flex;
		flex-wrap: wrap;

		border-bottom: solid 0.1em #adb5bd;
		padding-bottom: 0.2em;
		margin-bottom: 0.3em;
	}
	> .kt-sales-goals-content {
		height: inherit;
		// border: solid 0.1em red;
		div.card {
			margin-bottom: 1em;
			> div.card-header {
				padding: 0.2em;
				line-height: 1em;
				font-size: 0.9em;
				// text-align: left;
				display: flex;
				> button {
					height: 20px;
					line-height: inherit;
					padding: 0 0.2em;
					&.collapsed {
						transform: rotate(-90deg);
					}
					&:hover {
						background-color: #dee2e6;
					}
				}
				> span {
					padding-left: 0.5em;
					flex-grow: 1;
					margin: auto 0;
				}
				> select {
					width: 60px;
					font-size: 0.9em;
				}
			}
			> div:nth-child(2) {
				padding: 0.2em 0.5em;

				p.note {
					padding: 1em 0;
					margin-bottom: 0;
					text-align: center;
					font-size: 14px;
				}
			}
		}
	}
}
#bc-sg-by-monthly,
#bc-sg-by-quarterly {
	font-size: 0.9em;

	> div > div.header {
		padding: 0.2em 0;
		display: flex;
		.btn {
			font-size: 0.9em;
			margin-right: 0.5em;
		}

		div.dropdown {
			margin-left: auto;
			ul.dropdown-menu {
				padding: 0.5em 0;
			}
			.dropdown-item {
				width: 100px;
				padding: 0.2em 0.5em;
				display: flex;
				input {
					margin: auto 0;
				}
				span {
					cursor: default;
					padding-left: 0.5em;
					// font-size: 0.9em;
				}
			}
		}
	}

	> div > div.content {
		overflow-x: auto;

		> div.info {
			text-align: left;

			> div {
				display: flex;
				// flex-wrap: nowrap;
				margin-bottom: 0.5em;
				> span:first-child {
					width: 25px;
					flex-shrink: 0;
					text-align: center;
					> svg {
						font-size: 1.2em;
						color: #dc3545;
					}
				}
				> span:nth-child(2) {
					font-size: 0.9em;
				}
			}
		}
	}
	table {
		font-size: 0.9em;
		width: unset;

		thead {
			tr th {
				vertical-align: middle;
				padding: 0.2em 0.5em;
				// text-align: center;
				min-width: 90px;
				// border-bottom: solid 0.1em #343a40;
				border: none;
				font-weight: normal;
			}
			th.yr {
				// height: 31px;

				> span:nth-of-type(2) {
					vertical-align: middle;
					font-weight: bold;
					margin: 0 0.4em;
				}

				> .dropdown {
					.dropdown-toggle {
						font-size: 0.9em;
						svg {
							color: #4fa4ff;
						}
					}
					.dropdown-item {
						border-bottom: solid 0.1em #ced4da;
						padding: 0.2em 0.5em;
						min-width: 100px;

						cursor: pointer;
						svg {
							margin-right: 0.4em;
							color: #6c757d;

							&.fa-check {
								color: #28a745;
							}
							&.fa-times {
								color: #dc3545;
							}
							&.fa-pencil-alt {
								color: #4fa4ff;
							}
						}

						// &.ovrAct svg.fa-pencil-alt {
						// 	color: #dc3545;
						// }
					}
					&.no-tgt-col .tgl-tgt:after {
						content: "Show Targets";
					}
					&:not(.no-tgt-col) .tgl-tgt:after {
						content: "Hide Targets";
					}
				}
				> .btns {
					padding-bottom: 0.4em;
					button {
						font-size: 1em;
						margin: 0 0.2em;
					}
				}
			}

			tr.tgt-act {
				th {
					line-height: 1em;
					text-align: right;
					padding-right: 0.5em;
					padding-bottom: 0.4em;
					border-bottom: solid 0.2em #6c757d;
				}
				th.Tgt::before {
					content: "Target";
				}
				// th.ActOvrd,
				th.Act {
					&::before {
						content: "Actual";
					}
					svg {
						color: #dc3545;
						margin-left: 0.75em;
					}
				}
			}
		}
		tbody {
			tr td {
				padding: 0.3em 0.5em;
				vertical-align: middle;
			}
			tr td:first-child {
				text-align: left;
				// border-right: solid 0.1em #ced4da;
			}
			tr td:not(:first-child) {
				text-align: right;
				font-size: 0.85em;
				height: 31px;

				> div.input-group {
					max-width: 110px;
					margin: 0 auto;
				}
				div.input-group-text {
					font-size: 1em;
					// background-color: #f8f9fa ;
				}

				> span,
				> div input {
					line-height: 1em;
					font-size: 1.3em;
					text-align: right;
				}
				> span {
					display: inline-block;
					&::before {
						content: "$";
					}
					&:empty::before {
						content: "-";
						padding-right: 0.5em;
					}
				}
				&.Act.ActOvrd {
					> div,
					> span {
						&::after {
							content: "*";
							padding-left: 0.2em;
						}
					}
				}

				svg {
					margin: auto 0;
					margin-left: 0.3em;
					color: #dc3545;
					// &.fa-pencil-alt {
					// 	font-size: 9px;
					// }
					&.fa-exclamation {
						font-size: 11px;
					}
				}

				&.Tgt {
					padding-left: 1em;
				}
			}

			tr:last-child {
				background-color: #f8f9fa;
				font-size: 1.1em;
				td {
					padding: 0.6em 0.3em;
					border-top: solid 0.2em #343a40;
					font-weight: bold;
				}
				input {
					font-weight: bold;
				}
			}
		}

		thead tr th.yr,
		thead tr th.Act,
		tbody tr td.Act {
			&:not(:last-child) {
				border-right: solid 0.3em #dee2e6;

				&:not(.yr) {
					padding-right: 1em;
				}
			}
		}
	}

	input:invalid {
		border-color: #dc3545;
		box-shadow: none;
	}
}

#bc-sg-quest-tg {
	// overflow-x: auto;
	max-width: 800px;
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;

	> div {
		// border: solid 0.1em red;
		margin-bottom: 0.5em;
		padding-right: 1em;
		flex-grow: 1;
		text-align: left;

		> div.hdr {
			font-size: 0.9em;
			font-weight: bolder;
			padding-bottom: 0.5em;
			text-decoration: underline;
		}

		> div.item {
			display: flex;
			font-size: 0.9em;
			padding: 0.2em 0;

			> div:nth-child(2) {
				span:nth-child(1) {
					font-weight: bolder;
				}
				span:nth-child(2) {
					padding-left: 0.4em;
					font-size: 0.85em;
				}
			}
		}
	}
	> div.goal {
		// > div.progress {
		// 	max-width: 330px;
		// 	margin: 0.4em 0;
		// }
		> #vue-gauge {
			padding: 0 1em;
			svg {
				overflow: visible;
				> text:first-of-type {
					font-size: 11px;
				}
				> text:last-of-type {
					font-size: 12px;
					transform: translateX(0.5em);
				}
			}
		}
		> div.item {
			> div:first-child {
				width: 100px;
			}

			// &.Rem div:nth-child(2) {
			// 	color: #dc3545;
			// }
			&.Exc div:nth-child(2) {
				color: #28a745;
			}
		}
	}
	> div.ppl {
		> div.item {
			> div:first-child {
				width: 220px;
				flex-shrink: 0;
				.tt-info svg {
					margin: 0 0.2em;
				}
			}
			> div:nth-child(2) {
				span:empty::before {
					content: "-";
					font-weight: normal;
				}
			}
		}
	}
}

#bc-sg-notes {
	max-width: 800px;
	> div {
		text-align: left;
		padding: 0.5em;
		margin: 0.5em 0;

		border: solid 0.1em #ced4da;
		// border: solid 0.1em red;
		> div.title {
			font-weight: bolder;
			font-size: 0.85em;
			text-decoration: underline;
		}
		// > div.items-cont {
		// 	// border: solid 0.1em #ced4da;
		// 	// border-radius: 0.25em;
		// 	// max-height: 300px;
		// 	// overflow-y: auto;
		// }

		> div.items-cont > div.item {
			padding: 0.2em;
			// margin-bottom: 0.5em;
			> div.input-group {
				width: unset;
				flex-grow: 1;
				textarea {
					line-height: 1em;
					min-height: 50px;
					max-height: 200px;
					// background-color: #f8f9fa;
				}
				.input-group-append {
					// border: solid 0.1em red;
					flex-wrap: wrap;
					align-self: flex-start;
					width: 30px;
					.btn {
						width: 20px;
						height: 20px;
						opacity: 0.6;
						// background-color: #e9ecef;
						box-shadow: unset;
						font-size: 0.9em;

						margin: 0 auto;
						margin-bottom: 0.5em;
						padding: 0;
						&:hover {
							opacity: unset;
							background-color: #e9ecef;
							border-radius: 0.25em;
						}
					}
					.btn-delete {
						color: #dc3545;
					}
					.btn-edit {
						color: #4fa4ff;
					}
					.btn-save {
						color: #28a745;
					}
				}
			}

			> div.info {
				text-align: right;
				padding-right: 30px;
				line-height: 0.9em;
				span {
					font-size: 0.75em;
					padding-right: 0.5em;
				}
			}
		}

		> .btn-add {
			font-size: 0.9em;
		}
	}
}

.modal .modal-dialog #bm-create-goal-yr {
	padding-top: 0.5em;
	> select {
		width: unset;
	}
	> p {
		font-size: 0.9em;
		color: #495057;
	}
}
</style>

